export const fileConfig = {
    fileUploadMaxSize: 1024 * 1024 * 20, // allow limit to 20MB
}